import SuccessorBorrowerSnapshots from './SuccessorBorrowerSnapshots';

export default SuccessorBorrowerSnapshots;
